$(document).ready(function() {
    $('.video-thumbnail').on('click', function () {
        playEmbededVideos(this);
    });
    replaceVideoWithThumbnail();
});

function replaceVideoWithThumbnail(){
    $('.video').each(function(){
        var $rawVideo = $(this).find('.video-embeded');
        var $thumbNail = $(this).find('.video-thumbnail');
        if($thumbNail.length > 0){
            $rawVideo.hide();
        }
    });
}

function playEmbededVideos(videoThumbnail) {
    var videoEmbeded = $(videoThumbnail).parent().find(".video-embeded");
    var iframe = videoEmbeded.find("iframe");
    var videoURL = iframe.prop('src');

    iframe.prop('src',videoURL += "?rel=0&autoplay=1");

    setTimeout(function(){
        $(videoThumbnail).hide();
        videoEmbeded.show();
    }, 200);
}


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/grid-content.js
// module id = 19
// module chunks = 0